module.exports = __webpack_public_path__ + "static/media/microsoft-powerpoint-logo.363b1daf.png";